var _rect, _rect2, _rect3, _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSortAsc = function SvgSortAsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    x: 11,
    y: 5,
    fill: "currentColor",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 11,
    y: 11,
    fill: "currentColor",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 11,
    y: 17,
    fill: "currentColor",
    rx: 1
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "sort-asc_svg__a",
    width: 8,
    height: 16,
    x: 2,
    y: 4,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 4h8v16H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.204 8.892a.694.694 0 0 1-.015-.968L5.77 5.21A.66.66 0 0 1 6.248 5a.66.66 0 0 1 .481.21l2.58 2.714a.694.694 0 0 1-.014.968.66.66 0 0 1-.948-.015L6.92 7.375v10.94c0 .379-.3.685-.67.685a.677.677 0 0 1-.67-.684V7.376L4.151 8.876a.66.66 0 0 1-.948.015"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.204 8.892a.694.694 0 0 1-.015-.968L5.77 5.21A.66.66 0 0 1 6.248 5a.66.66 0 0 1 .481.21l2.58 2.714a.694.694 0 0 1-.014.968.66.66 0 0 1-.948-.015L6.92 7.375v10.94c0 .379-.3.685-.67.685a.677.677 0 0 1-.67-.684V7.376L4.151 8.876a.66.66 0 0 1-.948.015"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.19 7.924.144.138zm6.12 0 .146-.138zm-.962.953-.145.138zM6.92 7.375h-.2v-.5l.345.362zm-1.34 0-.146-.137.345-.363v.5zM4.151 8.877l.145.138zm-1.089.157a.894.894 0 0 1-.019-1.248l.29.276a.494.494 0 0 0 .01.688zm-.019-1.248 2.58-2.713.29.275-2.58 2.714zm2.581-2.715.001-.001.006-.006c.278.005.282.284.28.285v.001H5.91v.001l-.001.001c-.002.001-.28.002-.29-.275zl.286.28V5.35h.001l.005-.006c-.01-.277-.289-.276-.29-.275v.001zl-.002.002c-.001.001.003.28.28.285l.007-.006zm-.002.002A.86.86 0 0 1 6.25 4.8v.4a.46.46 0 0 0-.336.148zM6.25 4.8a.86.86 0 0 1 .626.273l-.29.275A.46.46 0 0 0 6.25 5.2zm.623.27-.006-.006c-.278.005-.282.283-.28.285v.001h.001l.001.002c.001 0 .28.002.29-.276zl-.286.28V5.35h-.001v-.001l-.005-.005c.01-.278.288-.277.29-.275zh.001v.002c.002.001-.002.28-.28.285L6.59 5.35h-.001zm.002.002 2.58 2.714-.29.276-2.58-2.714zm2.58 2.714a.894.894 0 0 1-.018 1.248l-.281-.284a.494.494 0 0 0 .01-.688zm-.018 1.248a.86.86 0 0 1-1.234-.02l.29-.275a.46.46 0 0 0 .662.01zm-1.234-.02L6.775 7.514l.29-.276L8.493 8.74zM7.12 7.376v10.94h-.4V7.376zm0 10.94a.877.877 0 0 1-.87.885v-.4c.256 0 .47-.213.47-.485zm-.87.885c-.485 0-.87-.4-.87-.884h.4c0 .271.213.484.47.484zm-.87-.884V7.376h.4v10.94zm.344-10.803L4.297 9.015l-.29-.276 1.427-1.501zM4.297 9.015a.86.86 0 0 1-1.234.019l.281-.284a.46.46 0 0 0 .663-.01z",
    mask: "url(#sort-asc_svg__a)"
  })));
};
export default SvgSortAsc;